import React from "react";
import { Routes, Route } from "react-router-dom";

import Homepage from "./HomePage/HomePage.jsx";
import Homepage2 from "./HomePage2/HomePage2.jsx";
import Homepage3 from "./HomePage3/Homepage3.jsx";
import AboutPage from "./AboutPage/AboutPage.jsx";
import BlogPage from "./BlogPage/BlogPage.jsx";
import BlogPageLeft from "./BlogPageLeft/BlogPageLeft.jsx";
import BlogPageFullwidth from "./BlogPageFullwidth/BlogPageFullwidth.jsx";
import BlogDetails from "./BlogDetails/BlogDetails.jsx";
import BlogDetailsFull from "./BlogDetailsFull/BlogDetailsFull.jsx";
// NOTE: double-check this filename really is “BlogDetailsLeftSiide.jsx” (two i’s)
import BlogDetailsLeftSiide from "./BlogDetailsLeftSiide/BlogDetailsLeftSiide.jsx";
import ContactPage from "./ContactPage/ContactPage.jsx";
import ErrorPage from "./ErrorPage/ErrorPage.jsx";
import TeamSinglePage from "./TeamSinglePage/TeamSinglePage.jsx";
import ServicePage from "./ServicePage/ServicePage.jsx";
import ServicePageS2 from "./ServicePageS2/ServicePageS2.jsx";
import ServiceSinglePage from "./ServiceSinglePage/ServiceSinglePage.jsx";
import ProjectPage from "./ProjectPage/ProjectPage.jsx";
import ProjectSinglePage from "./ProjectSinglePage/ProjectSinglePage.jsx";
import AppointmentPage from "./AppointmentPage/AppointmentPage.jsx";
import Proposal from "./Proposal/Proposal.jsx";
import TermPage from "./TermPage/TermPage.jsx";
import TestimonialPage from "./TestimonialPage/TestimonialPage.jsx";
import LoginPage from "./LoginPage/LoginPage.jsx";
import SignUpPage from "./SignUpPage/SignUpPage.jsx";
import ForgotPassword from "./ForgotPassword/ForgotPassword.jsx";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/home" element={<Homepage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/home2" element={<Homepage2 />} />
      <Route path="/home3" element={<Homepage3 />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/service" element={<ServicePage />} />
      <Route path="/service-s2" element={<ServicePageS2 />} />
      <Route path="/service-single/:id" element={<ServiceSinglePage />} />
      <Route path="/project" element={<ProjectPage />} />
      <Route path="/project-single/:id" element={<ProjectSinglePage />} />
      <Route path="/appointment" element={<AppointmentPage />} />
      <Route path="/Proposal" element={<Proposal />} />
      <Route path="/terms" element={<TermPage />} />
      <Route path="/testimonial" element={<TestimonialPage />} />
      <Route path="/blog-single/:id" element={<BlogDetails />} />
      <Route path="/blog-single-left-sidebar/:id" element={<BlogDetailsLeftSiide />} />
      <Route path="/blog-single-fullwidth/:id" element={<BlogDetailsFull />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog-left-sidebar" element={<BlogPageLeft />} />
      <Route path="/blog-fullwidth" element={<BlogPageFullwidth />} />
      <Route path="/team-single/:id" element={<TeamSinglePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<SignUpPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      {/* Catch-all 404 */}
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}
